import { render, staticRenderFns } from "./adminSeckillOrder.vue?vue&type=template&id=0f8c2d7a&scoped=true"
import script from "./adminSeckillOrder.vue?vue&type=script&lang=js"
export * from "./adminSeckillOrder.vue?vue&type=script&lang=js"
import style0 from "./adminSeckillOrder.vue?vue&type=style&index=0&id=0f8c2d7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8c2d7a",
  null
  
)

export default component.exports